import { ChangeDetectionStrategy, Component, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { getWindow } from 'ssr-window';
import {
  development,
  server,
  softwares,
  topNavigation,
  webBasedServiceLinks
} from '../sitemule-data';

import { isPlatformBrowser } from '@angular/common';
import { YoutubeModalComponent } from 'src/app/components/youtube-modal/youtube-modal.component';
import { environment } from 'src/environments/environment';
import { content, githubLink, images, links } from './data';

@Component({
  selector: 'app-sitemule-solutions',
  templateUrl: './solutions.component.html',
  styleUrls: ['./solutions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SitemuleSolutionsComponent {

  constructor(@Inject(PLATFORM_ID) private platformId: string) {}
  isPlatformBrowser = isPlatformBrowser(this.platformId);

  webBasedServiceLinks = webBasedServiceLinks;
  softwares = softwares;
  development = development;
  server = server;
  allPersons = environment.data.allPersons.filter(
    (person) => person.showInSmallSize
  );
  topNavigation = topNavigation;
  content = content;
  contacts = environment.data.contacts;
  githubLink = githubLink;
  links = links;
  customers = environment.data.customers;
  images = images;
  image = '../../../../assets/images/hero-1.jpg';

  @ViewChild('youtubeRef') youtubeModal!: YoutubeModalComponent;

  get initialFontSize() {
    const win = getWindow();
    if (win.innerWidth < 450) {
      return 45;
    }
    if (win.innerWidth < 850) {
      return 89;
    }
    if (win.innerWidth < 1500) {
      return 91;
    }
    if (win.innerWidth < 1800) {
      return 110;
    }
    if (win.innerWidth < 3100) {
      return 120;
    }
    return (win.innerWidth / 100) * 4;
  }

  showYoutubeModal() {
    if (this.youtubeModal) {
      this.youtubeModal.showVideo();
    }
  }
}
